import { Bar } from 'vue-chartjs'
import acordo from "@/services/acordo";

export default {
  extends: Bar,
  async mounted () {
    
    let parcelas = await acordo.getGraph();

    // Overwriting base render method with actual data.
    this.renderChart({
      labels: parcelas.map((item) => {return item._id}), //['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [
        {
          label: 'Valor de Acordos',
          backgroundColor: '#092dbd',
          data: parcelas.map((item) => {return item.valor}),//[40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
        }
      ]
    })
    
  }
}


// WEBPACK FOOTER //
// ./src/components/ValoresParcela.js